export default Object.freeze({
  UNAUTHORIZED: 401,
  NETWORK: 499,
  SERVER: 500,
  FORBIDDEN: 403,
  NOT_FOUND: 404
})
